import React from 'react'

function AvgCell({avg}) {
  return (
    <th>{avg}</th>
  )
}

export default AvgCell
